import type { TemplateConfig } from './constants.extra'

/**
 * THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
 * Generated from /networks/gravity/config.json
 */
const TEMPLATE_CONFIG = {
  EIP155: false,
  SUPPORTED_VERSIONS: ['1.3.0', '1.4.1'],
  SAFE_UTILS_SUPPORTED: false,
  EXTRA_FOOTER_LINKS: [
    { label: 'X', link: 'https://x.com/Galxe' },
    { label: 'Discord', link: 'https://discord.com/invite/galxe' },
  ],
  IS_LICENSED: false,
  LOGO_DIMENSIONS: {
    HEADER: {
      H: '40px',
    },
    WELCOME: {
      W: '120px',
      H: '64px',
    },
  },
} as TemplateConfig
export default TEMPLATE_CONFIG
